import { render, staticRenderFns } from "./PulseScoreGauge.vue?vue&type=template&id=107515d9&scoped=true"
import script from "./PulseScoreGauge.vue?vue&type=script&lang=ts"
export * from "./PulseScoreGauge.vue?vue&type=script&lang=ts"
import style0 from "./PulseScoreGauge.vue?vue&type=style&index=0&id=107515d9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107515d9",
  null
  
)

export default component.exports